// Messages for operator/shipments/LegFormModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.leg_form.mode.ship': 'Ocean',
  'operator.leg_form.mode.air': 'Air',
  'operator.leg_form.mode.truck': 'Truck',
  'operator.leg_form.mode.train': 'Rail',
  'operator.leg_form.title.edit': 'Edit leg',
  'operator.leg_form.title.add': 'Add leg',
  'operator.leg_form.cancel': 'Cancel',
  'operator.leg_form.save': 'Save leg',
  'operator.leg_form.add': 'Add leg',
  'operator.leg_form.field.carrier': 'Carrier',
  'operator.leg_form.carrier_aria': 'Carrier',
  'operator.leg_form.carrier_placeholder': 'Select a carrier',
  'operator.leg_form.field.mode': 'Mode',
  'operator.leg_form.mode_aria': 'Mode',
  'operator.leg_form.field.origin': 'Origin',
  'operator.leg_form.origin_aria': 'Origin',
  'operator.leg_form.location_create': 'Create "{name}"',
  'operator.leg_form.field.destination': 'Destination',
  'operator.leg_form.destination_aria': 'Destination',
  'operator.leg_form.location_placeholder': 'Search ports, airports, cities…',
  'operator.leg_form.field.atd': 'ATD',
  'operator.leg_form.atd_aria': 'ATD',
  'operator.leg_form.field.etd': 'ETD',
  'operator.leg_form.etd_aria': 'ETD',
  'operator.leg_form.field.eta': 'ETA',
  'operator.leg_form.eta_aria': 'ETA',
  'operator.leg_form.completed': 'Leg completed',
}

export const zhTW = {
  'operator.leg_form.mode.ship': '海運',
  'operator.leg_form.mode.air': '空運',
  'operator.leg_form.mode.truck': '卡車',
  'operator.leg_form.mode.train': '鐵路',
  'operator.leg_form.title.edit': '編輯航段',
  'operator.leg_form.title.add': '新增航段',
  'operator.leg_form.cancel': '取消',
  'operator.leg_form.save': '儲存航段',
  'operator.leg_form.add': '新增航段',
  'operator.leg_form.field.carrier': '承運商',
  'operator.leg_form.carrier_aria': '承運商',
  'operator.leg_form.carrier_placeholder': '選擇承運商',
  'operator.leg_form.field.mode': '運輸方式',
  'operator.leg_form.mode_aria': '運輸方式',
  'operator.leg_form.field.origin': '起點',
  'operator.leg_form.origin_aria': '起點',
  'operator.leg_form.location_create': '新增「{name}」',
  'operator.leg_form.field.destination': '目的地',
  'operator.leg_form.location_placeholder': '搜尋港口、機場、城市…',
  'operator.leg_form.destination_aria': '目的地',
  'operator.leg_form.field.atd': 'ATD',
  'operator.leg_form.atd_aria': 'ATD',
  'operator.leg_form.field.etd': 'ETD',
  'operator.leg_form.etd_aria': 'ETD',
  'operator.leg_form.field.eta': 'ETA',
  'operator.leg_form.eta_aria': 'ETA',
  'operator.leg_form.completed': '航段已完成',
}
